if (!customElements.get('janome-product-tabs')) {
  customElements.define('janome-product-tabs', class extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
      this.select = button => {
        this.tabs.forEach(tab => {const active = tab === button;tab.classList.toggle('active', active);tab.setAttribute('aria-selected', String(active));});
        this.panels.forEach(panel => {const active = panel.id === button.getAttribute('aria-controls');panel.classList.remove('hidden','block');panel.hidden = !active;panel.style.display = active ? 'block' : 'none';});
      };
      this.click = event => {const button = event.target.closest('[role="tab"]');if (button && this.contains(button)) this.select(button);};
      this.key = event => {
        const current = this.tabs.indexOf(document.activeElement);
        if (current < 0 || !['ArrowRight','ArrowLeft','Home','End'].includes(event.key)) return;
        event.preventDefault();
        let next = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
        this.tabs[next].focus();this.select(this.tabs[next]);
      };
      this.addEventListener('click',this.click);this.addEventListener('keydown',this.key);
      if (this.tabs.length) this.select(this.tabs[0]);
    }
    disconnectedCallback() {this.removeEventListener('click',this.click);this.removeEventListener('keydown',this.key);}
  });
}
